<template>
    <div
        id="carrello"
        class="bg-light"
    >
        <vue-headful :title="pageTitle" />
        <div class="body-wrapper">
            <gallery-header />

            <loading-animation
                class="loading"
                v-show="loading"
            />
            <main v-show="!loading">
                <div class="container-fluid mt-5">
                    <div class="row align-items-center">
                        <div class="col-md-6 col-lg-8">
                            <h2 class="titolo-pagina text-uppercase mb-0 text-center text-md-left">
                                {{ $t("Carrello") }}
                            </h2>
                            <p class="numero-prodotti mb-0 mt-1 text-center text-md-left">
                                {{ numCartItems }} {{ $t("prodotti") }}
                                <!--;
                                {{ $t("Subtotale") }}:
                                {{ cartTotal | toCurrency }}-->
                            </p>
                        </div>

                        <div class="azioni-carrello col-md-6 col-lg-4 mt-4 mt-md-0">
                            <ul class="d-flex justify-content-center justify-content-md-end mb-0">
                                <li>
                                    <button
                                        type="button"
                                        class="btn btn-primary btn-lg btn-rikorda1 btn-icon-right"
                                        role="button"
                                        v-if="hasItemsInCart"
                                        @click="gotoCheckout()"
                                    >
                                        {{ $t("Procedi con l'ordine") }}
                                        <font-awesome-icon :icon="['fas', 'chevron-right']" />
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="visualizzazione-carrello mt-5">
                    <div class="container-fluid">
                        <p
                            class="mb-0"
                            v-if="!cartItems.length"
                        >
                            {{ $t("Non ci sono prodotti nel carrello.") }}
                        </p>
                        <transition name="slide">
                            <div
                                id="cartNotificationsContainer"
                                v-if="updateCartError"
                            >
                                <ul id="cartNotifications">
                                    <li class="cart-notification">
                                        <span class="font-text">{{
                                            $t(
                                                "Qualcosa &egrave; andato storto. Riprova"
                                            )
                                        }}</span>
                                    </li>
                                </ul>
                            </div>
                        </transition>

                        <!--NUOVO CARRELLO: INIZIO-->
                        <div
                            v-show="cartItems.length"
                            class="tabella-carrello w-100 mb-0"
                        >
                            <div class="table-thead w-100">
                                <div class="table-tr d-flex py-2">
                                    <div class="px-1 px-md-2 px-lg-3 th-prodotto">{{$t("Articolo")}}</div>
                                    <div class="px-1 px-md-2 px-lg-3 text-left text-md-center th-qty">{{$t("Quantità")}}</div>
                                    <div class="px-1 px-md-2 px-lg-3 text-left text-md-center th-prezzo">{{$t("Prezzo")}}</div>
                                    <div class="px-1 px-md-2 px-lg-3 th-azioni"></div>
                                </div>
                            </div>
                            <div class="table-tbody w-100">
                                <div
                                    class="table-tr prodotto position-relative overflow-hidden d-md-flex align-items-center py-2"
                                    v-for="(cartItem, cartItemIndex) in cartItems"
                                    v-bind:key="cartItemIndex"
                                >
                                    <div class="clearfix d-md-none"></div>
                                    <div class="px-1 px-md-2 px-lg-3 border-0 colonna-foto">
                                        <div class="contenitore-img d-flex justify-content-center align-items-center flex-wrap w-100 position-relative">
                                            <div class="img-wrapper w-100 h-100 d-flex justify-content-center align-items-center">
                                                <img
                                                    :src="getUrl(cartItem)"
                                                    alt=""
                                                    class="mw-100 mh-100"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="px-1 px-md-2 px-lg-3 border-0 d-md-flex align-items-center colonna-info">
                                        <p class="col-12 col-md-6 col-lg-4 mb-0 p-0 pr-md-2 w-75 w-md-100 d-flex align-items-center nome-file">
                                            <span class="d-inline-block w-100">{{ cartItem.itemTitle }}</span>
                                        </p>
                                        <p class="col-12 col-md-6 col-lg-8 mb-0 p-0 pl-md-2 nome-prodotto font-titoli-rikorda text-blurikorda text-uppercase">{{ cartItem.articleName }}</p>
                                    </div>
                                    <div
                                        :title="$t('Quantità')"
                                        class="px-1 px-md-2 px-lg-3 border-0 mt-3 mt-md-0 text-left text-md-center colonna-qty"
                                    >
                                        <form class="selezione-quantita d-inline-flex align-items-center">
                                            <button
                                                class="btn btn-dark btn-rikorda2 rounded-circle"
                                                type="button"
                                                v-bind:disabled="
                                                        cartItem.articleQuantity <
                                                            2 || cartItem.busy"
                                                @click="
                                                        changeQty(
                                                            false,
                                                            cartItemIndex)"
                                            >
                                                <font-awesome-icon :icon="['fas', 'minus']" />
                                            </button>

                                            <input
                                                type="text"
                                                id="quantita"
                                                name="qty"
                                                v-model="cartItem.articleQuantity"
                                                min="1"
                                                class="mx-1 text-center"
                                                v-bind:class="{
                                                        updating: cartItem.busy
                                                    }"
                                                v-bind:disabled="
                                                        cartItem.busy
                                                    "
                                                @change="
                                                        onUpdateQty(
                                                            cartItemIndex)"
                                            />

                                            <div
                                                v-if="cartItem.busy"
                                                class="loading-indicator"
                                            >
                                                <div class="loading-square theme-background-color-primary"></div>
                                                <div class="loading-square theme-background-color-primary"></div>
                                                <div class="loading-square theme-background-color-primary"></div>
                                            </div>

                                            <button
                                                class="btn btn-dark btn-rikorda2 rounded-circle"
                                                type="button"
                                                @click="
                                                        changeQty(
                                                            true,
                                                            cartItemIndex
                                                        )
                                                    "
                                                v-bind:disabled="
                                                        cartItem.busy
                                                    "
                                            >
                                                <font-awesome-icon :icon="['fas', 'plus']" />
                                            </button>
                                        </form>
                                    </div>
                                    <div
                                        :title="$t('Prezzo')"
                                        class="px-1 px-md-2 px-lg-3 border-0 text-right text-md-left mt-3 mt-md-0 text-left text-md-center colonna-prezzo"
                                    >
                                        <p class="mb-0 text-blurikorda"><span class="d-md-none">{{$t("Prezzo")}}:</span>
                                            <span class="font-titoli-rikorda">
                                                {{+cartItem.articlePrice | toCurrency}}</span>
                                        </p>
                                    </div>
                                    <div
                                        data-title=""
                                        class="px-1 px-md-2 px-lg-3 border-0 mt-3 mt-md-0 colonna-azioni"
                                    >
                                        <ul class="azioni mb-0 text-md-right">
                                            <!--li class="modifica">
                                            <a href="#" :title="$t('Modifica')" class="d-none d-md-inline">
                                                <font-awesome-icon :icon="['fas', 'pencil-alt']"/>
                                                <span>{{$t("Modifica")}}</span></a>
                                            <a href="#" :title="$t('Modifica')"
                                               class="d-inline d-md-none btn btn-rikorda2-alt">
                                                <font-awesome-icon :icon="['fas', 'pencil-alt']"/>
                                                <span>{{$t("Modifica")}}</span></a>
                                        </li-->
                                            <li class="rimuovi d-inline-block d-md-block">
                                                <a
                                                    href=""
                                                    :title="$t('Rimuovi dal carrello')"
                                                    class="d-none d-md-inline"
                                                    @click.prevent="removePromptShow(cartItemIndex)"
                                                >
                                                    <font-awesome-icon :icon="['fa', 'times']" />&nbsp;
                                                    <span class="d-none d-lg-inline">{{$t("Rimuovi")}}</span>
                                                </a>
                                                <a
                                                    href=""
                                                    :title="$t('Rimuovi dal carrello')"
                                                    class="d-inline-block d-md-none btn btn-rikorda2-alt"
                                                    @click.prevent="removePromptShow(cartItemIndex)"
                                                >
                                                    <font-awesome-icon :icon="['fa', 'times']" />&nbsp;
                                                    <span class="d-none">{{$t("Rimuovi")}}</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="clearfix d-md-none"></div>
                                    <transition name="fade">
                                        <div
                                            class="d-flex justify-content-center align-items-center remove-prompt"
                                            v-if="cartItem.removePromptOpen"
                                        >
                                            <div>
                                                <h2 class="remove-prompt-text">
                                                    <span class="font-text">Rimuovere
                                                        {{cartItem.articleName}}?</span>
                                                </h2>
                                                <button
                                                    class="btn btn-no"
                                                    @click.prevent="removePromptHide(cartItemIndex)"
                                                    v-bind:disabled="cartItem.busy"
                                                >
                                                    No
                                                </button>
                                                <button
                                                    class="btn btn-yes"
                                                    v-bind:disabled="cartItem.busy"
                                                    @click.prevent="removeConfirm(cartItemIndex)"
                                                >
                                                    Sì
                                                </button>
                                            </div>
                                        </div>
                                    </transition>
                                </div>
                            </div>
                        </div>

                        <p
                            v-show="cartItems.length"
                            class="text-left text-md-right mt-5 mb-0"
                        >
                            {{$t('Data di consegna indicativa')}}:
                            <span class="font-titoli-rikorda text-blurikorda">{{deliveryDate | formatDateSlash}}</span>
                        </p>

                        <table
                            v-show="cartItems.length"
                            class="tabella-riepilogo-carrello table w-100 mt-5"
                        >
                            <tbody>
                                <tr>
                                    <td class="pl-0 text-left text-md-right">{{$t("Subtotale")}}</td>
                                    <td class="pr-0 font-titoli-rikorda text-blurikorda text-right">
                                        {{cartTotal | toCurrency}}
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        v-if="deliveryType==='F'"
                                        class="pl-0 text-left text-md-right"
                                    >{{$t("Spese di consegna in negozio")}}</td>
                                    <td
                                        v-if="deliveryType==='D'"
                                        class="pl-0 text-left text-md-right"
                                    >{{$t("Spese di spedizione")}}</td>
                                    <td class="pr-0 font-titoli-rikorda text-blurikorda text-right">{{shippingCost | toCurrency }}</td>
                                </tr>
                                <tr>
                                    <td class="pl-0 font-titoli-rikorda text-blurikorda text-left text-md-right">{{$t("Totale")}}</td>
                                    <td class="pr-0 font-titoli-rikorda text-blurikorda text-right">
                                        {{ cartTotal + shippingCost | toCurrency }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div
                            v-if="hasItemsInCart"
                            class="mt-3 text-center text-md-right"
                        >
                            <div class="d-md-inline-block mr-md-3 mb-3 mb-md-0">
                                <router-link
                                    :to="{name: 'gallery-dashboard'}"
                                    class="pulsante-aggiungi-prodotti btn btn-primary btn-lg btn-rikorda2-alt btn-icon-left"
                                >
                                    <font-awesome-icon :icon="['fas', 'plus']" />
                                    {{$t("Aggiungi prodotti")}}
                                </router-link>
                            </div>
                            <div class="d-md-inline-block">
                                <a
                                    href=""
                                    class="pulsante-continua-ordine btn btn-primary btn-lg btn-rikorda1 btn-icon-right"
                                    @click="gotoCheckout()"
                                >
                                    {{$t("Procedi con l'ordine")}}
                                    <font-awesome-icon :icon="['fas', 'chevron-right']" />
                                </a>
                            </div>
                        </div>
                        <!--NUOVO CARRELLO: FINE-->
                    </div>
                </div>
            </main>

            <gallery-footer />
        </div>
    </div>
</template>

<script>
import GalleryHeader from "../../components/gallery/Header";
import GalleryFooter from "../../components/gallery/Footer";
import SlideTransition from "../../components/gallery/SlideTransition";
import LoadingAnimation from "../../components/LoadingAnimation";

export default {
    name: "GalleryCart",
    components: {
        LoadingAnimation,
        GalleryHeader,
        GalleryFooter
    },

    data() {
        return {
            cart: null,
            loading: false,
            cartItems: [],
            notifyTimeout: 0,
            pageTitle: null,
            updateCartError: false,
            updateCartErrorTimeout: false,
            hasItemsInCart: false,
            shippingCost: 0,
            deliveryType: "",
            deliveryDate: null
        };
    },

    mounted() {
        this.pageTitle = "CARRELLO";

        this.loading = true;

        this.$store
            .dispatch("GET_CART_ITEMS")
            .then((result) => {
                console.log("GET_CART_ITEMS", result);
                this.cart = result.cart;
                for (var i = 0; i < this.cart.items.length; i++) {
                    this.cart.items[i].busy = false;
                }
                this.cartItems = this.cart.items;
                this.hasItemsInCart = this.cartItems.length > 0;
                this.shippingCost = result.shippingCost;
                this.deliveryType = result.deliveryInfo.deliveryType;
                if (result.deliveryInfo.deliveryDate) {
                    this.deliveryDate = result.deliveryInfo.deliveryDate;
                }
            })
            .catch((error) => {
                console.error("GET_CART_ITEMS", error);
                this.$router.push({ name: "gallery-dashboard" });
            })
            .finally(() => {
                this.loading = false;
            });
    },

    methods: {
        cartItemSubtotal(cartItem) {
            var subTotal = cartItem.articlePrice * cartItem.articleQuantity;
            return subTotal.toFixed(2);
        },

        changeQty(increment, cartItemIndex) {
            var cartItem = this.cartItems[cartItemIndex];
            if (increment) {
                cartItem.articleQuantity++;
            } else {
                cartItem.articleQuantity--;
            }

            this.updateQty(cartItemIndex);
        },

        getUrl(item) {
            var url = "";
            switch (item.itemType) {
                case "album":
                    url = this.$imagesService.getUrl(
                        item.photoId,
                        "event-web",
                        true
                    );
                    break;
                case "project":
                    url = this.$imagesService.getProjectUrl(
                        this.cart.eventId,
                        item.projectId
                    );
                    break;
            }
            return url;
        },

        gotoCheckout() {
            this.$router.push({
                name: "gallery-checkout",
                params: {
                    galleryUrl: this.$route.params.galleryUrl
                }
            });
        },

        onUpdateQty(cartItemIndex) {
            this.updateQty(cartItemIndex);
        },

        removeConfirm(cartItemIndex) {
            var cartItem = this.cartItems[cartItemIndex];
            cartItem.busy = true;
            this.cartItems.splice(cartItemIndex, 1, cartItem);

            this.$store
                .dispatch("REMOVE_ITEM_FROM_CART", {
                    photoId: cartItem.photoId,
                    articleCode: cartItem.articleCode
                })
                .then((result) => {
                    console.debug("REMOVE_ITEM_FROM_CART", result);
                    cartItem.busy = false;
                    cartItem.removePromptOpen = false;
                    this.cartItems.splice(cartItemIndex, 1);
                    this.hasItemsInCart = result.userState.numCartItems > 0;
                })
                .catch((error) => {
                    console.error("REMOVE_ITEM_TO_CART", error);
                    cartItem.busy = false;
                    cartItem.removePromptOpen = false;
                    this.updateCartError = true;
                    clearTimeout(this.updateCartErrorTimeout);
                    this.updateCartErrorTimeout = setTimeout(
                        () => (this.updateCartError = false),
                        2000
                    );
                });
        },

        removePromptHide(cartItemIndex) {
            var cartItem = this.cartItems[cartItemIndex];
            cartItem.removePromptOpen = false;
            this.cartItems.splice(cartItemIndex, 1, cartItem);
        },

        removePromptShow(cartItemIndex) {
            var cartItem = this.cartItems[cartItemIndex];
            cartItem.removePromptOpen = true;
            this.cartItems.splice(cartItemIndex, 1, cartItem);
        },

        setPageTitle() {
            if (this.gallery) {
                this.pageTitle = [
                    this.gallery.title,
                    this.$t("di"),
                    this.gallery.author,
                    "- Rikorda"
                ].join(" ");
            }
        },

        updateQty(cartItemIndex) {
            var cartItem = this.cartItems[cartItemIndex];
            cartItem.busy = true;
            this.cartItems.splice(cartItemIndex, 1, cartItem);

            this.$store
                .dispatch("ADD_ITEM_TO_CART", {
                    photoId: cartItem.photoId,
                    articleCode: cartItem.articleCode,
                    quantity: cartItem.articleQuantity,
                    projectId: cartItem.projectId
                })
                .then((result) => {
                    cartItem.busy = false;
                    this.cartItems.splice(cartItemIndex, 1, cartItem);
                })
                .catch((error) => {
                    console.error("ADD_ITEM_TO_CART", error);
                    cartItem.busy = false;
                    this.updateCartError = true;
                    clearTimeout(this.updateCartErrorTimeout);
                    this.updateCartErrorTimeout = setTimeout(
                        () => (this.updateCartError = false),
                        2000
                    );
                });
        }
    },

    computed: {
        cartTotal() {
            var userState = this.$store.getters.userState;
            return userState && userState.cartTotal ? userState.cartTotal : 0;
        },

        numCartItems() {
            var userState = this.$store.getters.userState;
            return userState && userState.numCartItems
                ? userState.numCartItems
                : 0;
        }
    }
};
</script>

<style scoped>
.loading {
    position: absolute;
    top: 50%;
    left: calc(50% - 41px);
}

.visualizzazione-carrello .selezione-quantita .btn[disabled] {
    cursor: not-allowed;
}

.visualizzazione-carrello .selezione-quantita input.updating {
    color: white;
}

.visualizzazione-carrello .selezione-quantita .loading-indicator {
    text-align: center;
    float: left;
    display: inline-block;
    width: 42px;
    height: 42px;
    padding: 8px 0 0 0;
    margin: 0 20px 0 -56px;
}

@-webkit-keyframes loadingAnimation {
    0% {
        opacity: 0;
    }

    20% {
        opacity: 0.2;
    }

    40% {
        opacity: 0.4;
    }

    60% {
        opacity: 0.6;
    }

    80% {
        opacity: 0.8;
    }

    100% {
        opacity: 1;
    }
}

@keyframes loadingAnimation {
    0% {
        opacity: 0;
    }

    20% {
        opacity: 0.2;
    }

    40% {
        opacity: 0.4;
    }

    60% {
        opacity: 0.6;
    }

    80% {
        opacity: 0.8;
    }

    100% {
        opacity: 1;
    }
}

.visualizzazione-carrello
    .selezione-quantita
    .loading-indicator
    .loading-square {
    background-color: var(--tiffany);
    display: inline-block;
    -webkit-animation: loadingAnimation 0.8s ease-in-out infinite;
    animation: loadingAnimation 0.8s ease-in-out infinite;
    width: 4px;
    height: 4px;
    margin-right: 2px;
}

.visualizzazione-carrello
    .selezione-quantita
    .loading-indicator
    .loading-square:nth-child(1) {
    -webkit-animation-delay: 0;
    animation-delay: 0;
}

.visualizzazione-carrello
    .selezione-quantita
    .loading-indicator
    .loading-square:nth-child(2) {
    -webkit-animation-delay: 0.1s;
    animation-delay: 0.1s;
}

.visualizzazione-carrello
    .selezione-quantita
    .loading-indicator
    .loading-square:nth-child(3) {
    -webkit-animation-delay: 0.2s;
    animation-delay: 0.2s;
}

.visualizzazione-carrello #cartNotificationsContainer {
    z-index: 50;
}

.visualizzazione-carrello #cartNotificationsContainer ul {
    display: block;
    transform: scaleY(-1);
    list-style-type: none;
    padding: 0;
    margin: 0;
    background-color: #3f8bb3;
    background-color: var(--tiffany);
}

.visualizzazione-carrello #cartNotificationsContainer ul li {
    display: block;
    padding: 0;
    margin: 0;
    padding: 10px 20px 10px;

    transform: scaleY(-1);
    text-align: center;

    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    color: #fff;
}

@media (min-width: 768px) {
    .visualizzazione-carrello #cartNotificationsContainer ul {
        transform: scaleY(1);
    }

    .visualizzazione-carrello #cartNotificationsContainer ul li {
        transform: scaleY(1);
    }
}

.visualizzazione-carrello .prodotto .prodotto {
    position: relative;
}

.visualizzazione-carrello .prodotto .prodotto .detail {
    z-index: 10;
}

.visualizzazione-carrello .prodotto .remove-prompt {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 0;
    text-align: center;
    z-index: 99;
    background-color: var(--tiffany);
}

.visualizzazione-carrello .prodotto .remove-prompt.fade-enter-active,
.visualizzazione-carrello .prodotto .remove-prompt.fade-leave-active {
    transition: opacity 1s;
}
.visualizzazione-carrello .prodotto .remove-prompt.fade-enter,
.visualizzazione-carrello .prodotto .remove-prompt.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    z-index: 1;
}

.visualizzazione-carrello .prodotto .remove-prompt .remove-prompt-text {
    color: white;
}

.visualizzazione-carrello
    .prodotto
    .remove-prompt
    .remove-prompt-text
    .font-text {
    font-size: 26px;
    letter-spacing: 4px;
    line-height: 28px;
    margin-bottom: -9px;
}

.visualizzazione-carrello .prodotto .remove-prompt .btn {
    min-width: 160px;
    background-color: transparent;
    /*padding: 12px 19px 12px 19px;*/
    border-radius: 2px;
    margin: 0 8px;
    border: 2px solid #c7d2d6;
}

.visualizzazione-carrello .prodotto .remove-prompt .btn[disabled] {
    cursor: not-allowed;
}

.visualizzazione-carrello .prodotto .remove-prompt .btn h5 {
    font-size: 1em;
    line-height: 1.5;
}

.visualizzazione-carrello .prodotto .remove-prompt .btn.btn-no h5 {
    color: white;
}

.visualizzazione-carrello .prodotto .remove-prompt .btn.btn-yes {
    background-color: white;
}

.visualizzazione-carrello .prodotto .remove-prompt .btn.btn-yes h5 {
    /*color: white;*/
}
</style>
